<template>
  <div id="wrap">
    <app-header />
    <main>
      <h2><span>送信を完了しました。</span></h2>
      <div class="complete">
        <p class="mb1">
          {{ email }}
          宛てに、新規・無料ICタグお申込み用のURLをお送りいたしました。<br />
          メールのURLにアクセスの上、お申込みの手続きを行ってください。
        </p>
        <p>メールが届かない場合は、</p>
        <ul>
          <li>
            ・入力いただいたメールアドレスに誤りがある可能性がございます。<br />お手数ですが、<router-link
              :to="{ name: AppConst.ROUTENM.INDEX }"
              >こちらから連絡先メールアドレスの再入力</router-link
            >をお願いいたします。
          </li>
          <li>
            ・メールが受信できない設定をされていることがございます。<br /><a
              href="https://tsuitamon.jp/nondelivery/"
              target="_blank"
              >こちら</a
            >をご参照ください。
          </li>
        </ul>
      </div>
    </main>

    <app-footer />
    <scroll-to-top />
    <loading-anim
      v-bind:show="isLoading"
      :loaderColor="AppConst.LOADING.COLOR"
      :boxColor="AppConst.LOADING.BOXCOLOR"
    />
  </div>
</template>

<script>
import CmnSubMixin from "@mixins/cmnsub-mixin";
import HandleAjaxErrorMixin from "@mixins/handle-ajax-error-mixin";
import AppHeader from "@components/AppHeader";
import AppFooter from "@components/AppFooter";
import ScrollToTop from "@components/ScrollToTop";
import LoadingAnim from "@components/LoadingAnim";
import AppConst from "@utils/app-const";
import axios from "axios";

export default {
  name: "Home",
  mixins: [CmnSubMixin, HandleAjaxErrorMixin],
  components: {
    AppHeader,
    AppFooter,
    ScrollToTop,
    LoadingAnim,
  },
  data() {
    return {
      email: "",
      isLoading: false,
    };
  },
  mounted() {
    this.isLoading = true;
    // CSRFトークン取得
    axios.get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF).then(() => {
      axios
        .get(
          process.env.VUE_APP_API_BASE +
            AppConst.API.URL.TOKEN_INFO +
            "/" +
            this.$route.params.token
        )
        .then((response) => {
          this.isLoading = false;
          var res = response.data;
          this.email = res.data.email;
        });
    });
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        // ヒストリバックを使えなくする
        window.history.pushState(null, null, window.location.href);
      }
    });
    // ヒストリバックを使えなくする
    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", function () {
      window.history.go(1);
    });
  },
};
</script>
